import { Cup } from './Cup';
import { DiceHand } from './DiceHand';
import { UI } from './UI';
import { store } from '../stores/mainStore';
import {DicePopper} from './DicePopper';

export function create() {
	const m = window.manager;
	m.scene = this;
	store.phaserLoading = false;
	let showSize = false;

	manager.createScene = function (index) {
		if (store.isImmediateRematch) {
			store.setSpinner(false);
		}

		if (window.startTime) {
			console.log('load time', Math.round((Date.now() - window.startTime) / 100) / 10);
		}

		/* const loadSpriteSheet = (keyName, asset, obj) => {
			if(!this.textures.exists(keyName)) {
				if(showSize) {
					get_filesize(asset, function(size) {
						console.log('(CREATE) LOADING SPRITESHEET: '+asset+'\t\t SIZE: '+size);
						m.scene.load.once('complete', m.createOnComplete);
						m.scene.load.spritesheet(keyName, asset, obj);
						m.scene.load.start();
					});
				} else {
					console.log("(CREATE) LOADING SPRITESHEET: "+keyName);
					// store.debug = 'LOADING SPRITESHEET: '+keyName;
					m.scene.load.once('complete', m.createOnComplete);
					m.scene.load.spritesheet(keyName, asset, obj);
					m.scene.load.start();
				}
			}
		} */
		function get_filesize(url, callback) {
			var xhr = new XMLHttpRequest();
			xhr.open("HEAD", url, true); // Notice "HEAD" instead of "GET",
										 //  to get only the header
			xhr.onreadystatechange = function() {
				if (this.readyState === this.DONE) {
					callback(parseInt(xhr.getResponseHeader("Content-Length")));
				}
			};
			xhr.send();
		}
		const loadImage = (keyName, asset) => {
			if(!this.textures.exists(keyName)) {
				if(showSize) {
					get_filesize(asset, function(size) {
						console.log('(CREATE) LOADING IMAGE: '+asset+'\t\t SIZE: '+size);
						m.scene.load.once('complete', m.createOnComplete);
						m.scene.load.image(keyName, asset);
						m.scene.load.start();
					});
				} else {
					console.log("(CREATE) LOADING IMAGE: "+asset);
					// store.debug = 'LOADING IMAGE: '+keyName;
					m.scene.load.once('complete', m.createOnComplete);
					m.scene.load.image(keyName, asset);
					m.scene.load.start();
				}
			}
		}

		const endSeqLoading = () => {
			console.log("Create() sequential loading complete... setting up & creating anims... ");

			m.diceInstances = m.scene.add.group();
			m.handNameInstances = m.scene.add.group();
	
			let pushDownAmount = m.adjustY(45);

			var borderY = 70 * 2;
			borderY += pushDownAmount;
			let bounds = m.scene.matter.world
				.setBounds(20, borderY, m.config.width - 40, m.config.height - borderY)
				.disableGravity();
			Object.values(bounds.walls).forEach((o) => (o.label = 'bounds'));
	
			let bumper1 = m.scene.matter.add.image(m.adjustX(160) / 2, m.adjustY(25) + pushDownAmount, 'border')
				.setStatic(true).setFriction(0.005)
				.setScale(1, m.yAspectDiff).setAngle(-34);
			bumper1.body.label = 'bounds';
			let bumper2 = m.scene.matter.add.image(m.config.width - m.adjustX(160) / 2, m.adjustY(25) + pushDownAmount, 'border')
				.setStatic(true).setFriction(0.005)
				.setScale(1, m.yAspectDiff).setAngle(34);
			bumper2.body.label = 'bounds';
	
			m.scene.matter.world.on('collisionstart', (event) => {
				event.pairs.forEach((pair) => {
					const { bodyA, bodyB } = pair;
					var aIsDice = false, bIsDice = false;

					if (bodyA.label === 'bounds') bIsDice = true;
					if (bodyB.label === 'bounds') aIsDice = true;
	
					if (aIsDice) {
						m.ui.collisionStars(bodyA.position.x, bodyA.position.y);
					}
					if (bIsDice) {
						m.ui.collisionStars(bodyB.position.x, bodyB.position.y);
					}
				});
			});
	
			if (m.sceneFirstLoaded === false) {
				m.diceHand = new DiceHand(m);
				m.cup = new Cup(m);
				m.ui = new UI(m);
				m.popper = new DicePopper(m);
			}
			m.cup.waitForHandPointer = false;
	
			//m.playfield = m.scene.add.image(m.config.width / 2, 0, store.custom.table + '_gameBkg').setOrigin(0.5, 0).setInteractive();
			m.playfield = m.scene.add.image(m.config.width / 2, 0, 'gameBkg').setOrigin(0.5, 0).setInteractive();
			m.playfield.setScale(m.config.height / m.playfield.height);
			const watermark = m.scene.add.image(m.config.width / 2, m.config.height/2, 'watermark').setOrigin(0.5);
			watermark.setScale(0.9*m.config.width / watermark.width);
			store.setCustomHudBanners();
	
			//m.playfieldFrame = m.scene.add.image(m.config.width / 2, pushDownAmount, store.custom.table + '_playfieldFrame').setOrigin(0.5, 0).setDepth(2);
			m.playfieldFrame = m.scene.add.image(m.config.width / 2, pushDownAmount, 'playfieldFrame').setOrigin(0.5, 0).setDepth(2);
			m.playfieldFrame.setScale(m.config.width / m.playfieldFrame.width, m.config.width / m.playfieldFrame.width);
	
			m.playfieldLowPosition = m.playfieldFrame.y;
			let pfHeight = m.playfieldFrame.height * m.playfieldFrame.scaleY;
			let pfBottom = m.playfieldFrame.y + pfHeight;
			let upAmount = pfBottom - m.config.height;
			if (upAmount > 350) upAmount = 350;
			m.playfieldHighPosition = m.playfieldFrame.y - upAmount;
	
			m.cup.create();
			if (m.sceneFirstLoaded === false) {
				m.diceHand.create();
			} else {
				m.diceHand.reCreate();
			}
			m.popper.create();
	
			m.diceHand.clearDiceOffScreen();

			m.scene.anims.create({
				key: 'handSpin',
				frames: m.scene.anims.generateFrameNumbers('goalPanel', {
					start: 1,
					end: 5,
				}),
				frameRate: 30,
				repeat: -1,
			});

			m.scene.anims.create({
				key: 'flair',
				frames: m.scene.anims.generateFrameNumbers('flair', {
					start: 2,
					end: 9,
				}),
				frameRate: 10,
				repeat: -1,
			});
			m.scene.anims.create({
				key: 'selected',
				frames: m.scene.anims.generateFrameNumbers('flair', {
					start: 10,
					end: 25,
				}),
				frameRate: 20,
				repeat: -1,
			});
			/* m.scene.anims.create({
				key: 'flairYellowDot',
				frames: m.scene.anims.generateFrameNumbers('flairYellowDot', {
					start: 2,
					end: 9,
				}),
				frameRate: 10,
				repeat: -1,
			}); */
	
			m.scene.anims.create({
				key: 'handPoint',
				frames: m.scene.anims.generateFrameNumbers('hand', {
					start: 0,
					end: 1,
				}),
				frameRate: 2,
				repeat: 0,
			});
	
			//Poof
			var frameNames = m.scene.anims.generateFrameNames('poofNoCloud', {
				start: 1,
				end: 20,
				prefix: 'poof_no_cloud_',
				suffix: '.png',
			});
			m.scene.anims.create({
				key: 'poof',
				frames: frameNames,
				frameRate: 30,
				repeat: 0,
				hideOnComplete: true,
			});
	
			//Cup Swirl
			frameNames = m.scene.anims.generateFrameNames('swirl', {
				start: 1,
				end: 29,
				zeroPad: 4,
				prefix: 'swirl',
				suffix: '.png',
			});
			m.scene.anims.create({
				key: 'cupSwirl',
				frames: frameNames,
				frameRate: 30,
				repeat: -1,
			});
	
			//Floating Stars
			frameNames = m.scene.anims.generateFrameNames('floatingStars', {
				start: 2,
				end: 29,
				zeroPad: 4,
				prefix: 'floatingStars',
				suffix: '.png',
			});
			m.scene.anims.create({
				key: 'floatingStars',
				frames: frameNames,
				frameRate: 30,
				repeat: -1,
			});

			//store.phaserReady = true;
			//m.startMusic();
			m.onCreateComplete();
			store.setSpinner(false);
			m.sceneFirstLoaded = true;
			console.log("DONE w/ Create setup");
		}

		//m.createOnComplete = () => {loadNext();}
		m.createOnComplete = (...par) => {
			setTimeout(() => endSeqLoading(), 250);
		}
		//loadNext();
		// add here bot avatar loading
		const {image} = store.activeMatch.opponent
		if(this.textures.exists('oppAvatar'))
			this.textures.remove('oppAvatar')
		loadImage('oppAvatar', image || (m.assetURL + '/profile_default.jpg'))
	}.bind(this, store.phaserInstanceIndex);
}
